import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenue !");
      navigate("/app");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface flex flex-col items-center justify-center px-4 py-10">
      <Link to="/" className="mb-6"><Logo size={80} /></Link>
      <Card className="w-full max-w-md p-8 bg-white adminia-fade-in">
        <h1 className="font-heading font-bold text-2xl text-brand mb-1">Se connecter</h1>
        <p className="text-sm text-muted-foreground mb-6">Content de vous revoir sur ADMINIA.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">E-mail</Label>
            <Input id="email" type="email" required value={email} className="h-12 mt-1"
              onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div>
            <Label htmlFor="password">Mot de passe</Label>
            <Input id="password" type="password" required value={password} className="h-12 mt-1"
              onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading}
            className="w-full h-12 rounded-full bg-brand hover:bg-brand/90 text-base" data-testid="login-submit">
            {loading ? "Connexion…" : "Se connecter"}
          </Button>
        </form>
        <p className="text-sm text-center mt-6 text-muted-foreground">
          Pas encore de compte ?{" "}
          <Link to="/inscription" className="text-brand font-semibold" data-testid="to-register">S'inscrire</Link>
        </p>
      </Card>
    </div>
  );
}
